export default "__VITE_ASSET__C$GtJRxH__"